module.exports = __webpack_public_path__ + "static/condo_ux-2-ef4b97c00a18bdccda634776cf46eb30.jpg";